import Api from './Api';

class StorageManager {

    constructor() {

        this.content = {};
    }

    getFrom(link) {

        if (this.loading == undefined) {

            this.loading = new Promise((resolve) => {

                if (window.storageRuntimeData != undefined)
                    return resolve();

                if (link != window.location.href) {

                    const requestLink = `${link}${ link.indexOf('?') > -1 ? '&' : '?' }rnd=${ Math.random() }`;
                    Api
                        .fetch(requestLink, null, { STORAGE: 1 })
                        .then((response) => {
                        
                            window.storageRuntimeData = response;
                            resolve();
                        });
                }
            });
        }

        return this.loading;
    }
    
    get(storage, id, fromJson = false, throwError = true) {

        if (window.storageRuntimeData == undefined)
            throw this.error(id, storage);
            
        if (window.storageRuntimeData[storage] == undefined) {

            if (throwError)
                throw this.error(id, storage);
            
            return null;
        }

        const dataset = Object.values(window.storageRuntimeData[storage])[0];
        if (dataset == undefined) {

            if (throwError)
                throw this.error(id, storage);

            return null;
        }

        if (dataset[id] == undefined) {

            if (throwError)
                throw this.error(id, storage);

            return null;
        }

        return fromJson
            ? JSON.parse(dataset[id])
            : dataset[id];
    }

    error(id, storage) {

        return new Error(`Can't fetch ${id} from ${storage}`);
    }

}

export default new StorageManager();